/**
 * PROinfra Shared API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { Permission } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface PermissionServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * Returns all permissions
     * 
     */
    getAllPermissions(extraHttpRequestParams?: any): Observable<Array<Permission>>;

}
